module.exports = __webpack_public_path__ + "static/media/avatar.433583af.png";